/* eslint-disable no-sparse-arrays */
/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { controls } from '../../../../../redux/reducers/common/eventReducer';

import { extrudeSettings, railLoftModel, railModel } from '../../../../../utils/Functions';
import { MaterialTruss } from '../../../CustomMaterial';
import { trussDimensions } from '../../../../../helpers/building_component/truss/truss.helper';

const connectRailWidth = 0.3;
const connectRailHeight = 0.2;
const sideEdgeSlopeRailAlpha = Math.PI / 3.2;

const CommonTruss = ({ trussType, trussModelPosInfoArr, overlapTrussArr, normalMap, envMap, isShowSlopeRail=true, roofRailDistanceY=0, isFor }) => {
    const vector = new THREE.Vector3(1, 0, 0)

    const obj_upperTrussNormal = new THREE.Object3D();
    const obj_loftPieceRail = new THREE.Object3D();
    const obj_sideSlopeRail = new THREE.Object3D();
    const trussDimension = trussDimensions(isFor)
    
    const [upperTrussNormal, setUpperTrussNormal] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [sideSlopeRail, setSideSlopeRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [loftPieceRail, setLoftPieceRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    
    const sideEdgeSlopeRailLength = (trussType === "RBOAT" || trussType === "RBOBT" || trussType === "RBCAT" || trussType === "RBCBT") ? 3 : 2.5;
    const offset = params.p_b_t === 27 ? 0.04 : 0.035;
    const roofStylePosOffset = params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0;
    const roofAlpha = Math.atan(trussDimension.roofPitch / 12);

    const leftSideWallArr = {"c_b_l_w" : 'center', "c_b_l_s_w" : 'center', "L_L_R_S_W" : 'center', "G_F_L_R_W" : "gableFrontLean", "G_B_L_R_W" : "gableBackLean", "G_R_L_L_W" : "gableRightLean", "G_L_L_R_W" : "gableLeftLean"}
    const rightSideWallArr = {"c_b_r_w" : 'center', "c_b_r_s_w" : 'center', "R_L_L_S_W" : 'center', "G_F_L_L_W" : "gableFrontLean", "G_B_L_L_W" : "gableBackLean", "G_R_L_R_W" : "gableRightLean", "G_L_L_L_W" : "gableLeftLean"}
    
    const leftDoorDataArr = useMemo(() => (const_var.newDoorsArray.filter((item) => Object.keys(leftSideWallArr).includes(item.userData.wallName))), [const_var.newDoorsArray])
    const rightDoorDataArr = useMemo(() => (const_var.newDoorsArray.filter((item) => Object.keys(rightSideWallArr).includes(item.userData.wallName))), [const_var.newDoorsArray]) 

    const roofRailData = useMemo(() => {
        const dynamicHeight = params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right") ? (trussDimension.buildingHeight - ((trussDimension.roofPitch / 12) * (trussDimension.buildingWidth))) : trussDimension.buildingHeight;
        const pos_y = dynamicHeight - connectRailHeight / 2 + roofStylePosOffset;

        const lengthSingleSlope = Math.sqrt(Math.pow((trussDimension.buildingWidth - 0.1), 2) + Math.pow((trussDimension.roofPitch / 12) * (trussDimension.buildingWidth - 0.1), 2))
        let lengthStandard = 0;
        if (params.p_r_s === 1) {
            lengthStandard = Math.sqrt(Math.pow(trussDimension.buildingWidth / 2 + 0.08 - const_var.roofRegularDst, 2) + Math.pow((trussDimension.buildingWidth / 2 + 0.08 - const_var.roofRegularDst) * trussDimension.roofPitch / 12, 2))
        } else {
            lengthStandard = Math.sqrt(Math.pow((trussDimension.buildingWidth / 2), 2) + Math.pow((trussDimension.buildingWidth / 2) * trussDimension.roofPitch / 12, 2))
        }
        const roofRailLength = (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right")) ? lengthSingleSlope : lengthStandard;

        return {
            alpha: roofAlpha,
            length: roofRailLength,
            pos_x: -trussDimension.buildingWidth / 2 + (params.p_r_s === 1 ? const_var.roofRegularDst : connectRailHeight / 2),
            pos_y: pos_y + (params.p_r_s === 1 ? const_var.roofRegularDst * trussDimension.roofPitch / 12 - 0.02 :  + connectRailHeight / 2 * trussDimension.roofPitch / 12),
        }
    }, [trussDimension.buildingWidth, , trussDimension.buildingHeight, trussDimension.roofPitch, params.p_r_s, params.singleSlope, params.freeStandingSide])

    const sideEdgeSlopeRailPosY = useMemo(() => {
        let pitchOffset = 0
        if (trussType === 'SBST') pitchOffset = 0;
        else pitchOffset = (sideEdgeSlopeRailLength * Math.cos(sideEdgeSlopeRailAlpha)) * Math.tan(roofAlpha)

        return trussDimension.buildingHeight - (sideEdgeSlopeRailLength * Math.sin(sideEdgeSlopeRailAlpha) - pitchOffset) + roofStylePosOffset + (connectRailHeight / 2) * Math.cos(sideEdgeSlopeRailAlpha) - roofRailDistanceY;
    }, [trussDimension.buildingHeight, roofAlpha, roofStylePosOffset, params.p_r_s, trussDimension.roofPitch, trussType]);

    const singleSlopeBracesHeight = useMemo(() => {
        return (params.singleSlope && params.freeStandingSide === "left") ? sideEdgeSlopeRailPosY - ((trussDimension.roofPitch/12)*(trussDimension.buildingWidth)) : sideEdgeSlopeRailPosY
    }, [params.singleSlope, params.freeStandingSide, sideEdgeSlopeRailPosY, trussDimension.roofPitch, trussDimension.buildingWidth])

    const rightBraceHeight = useMemo(() => {
        if(params.singleSlope && params.freeStandingSide === "left"){
            return trussDimension.buildingHeight - sideEdgeSlopeRailLength * Math.sin(sideEdgeSlopeRailAlpha) - sideEdgeSlopeRailLength * Math.cos(sideEdgeSlopeRailAlpha) * Math.tan(roofAlpha);
        }else if((params.singleSlope && params.freeStandingSide === "right")){
            return trussDimension.buildingHeight + ((trussDimension.roofPitch/12)*(trussDimension.buildingWidth)) - (sideEdgeSlopeRailLength-(sideEdgeSlopeRailLength/3.2)) - ((trussDimension.roofPitch/12)*(3)) 
        }else{
            return sideEdgeSlopeRailPosY
        }
    }, [params.singleSlope, params.freeStandingSide, trussDimension.buildingHeight, trussDimension.roofPitch, trussDimension.buildingWidth, sideEdgeSlopeRailPosY])

    useMemo(() => {
            const instancedUpperTrussNormal = [];
            const instancedSideSlopeRail = [];
            const instancedLoftPieceRail = [];

            const frontLeftCornerBraceOverlapDoors = const_var.newDoorsArray.filter((item) => (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight) && ((
                (item.userData.wallName == "c_b_f_w" || item.userData.wallName == "c_b_l_s_f_w") && (isFor == 'center' || isFor == "gableFrontLean")) || 
                (item.userData.wallName == "G_F_L_B_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_B_L_B_W" && isFor == "gableBackLean") || 
                (item.userData.wallName == "G_L_L_B_W" && isFor == "gableLeftLean") || 
                (item.userData.wallName == "G_R_L_F_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "c_b_b_w" && isFor == "gableBackLean"))) ||

                ((((item.userData.wallName == "c_b_f_w" || item.userData.wallName == "c_b_r_s_f_w") && isFor == 'center') || 
                (item.userData.wallName == "G_F_L_B_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_L_L_B_W" && isFor == "gableLeftLean") || 
                (item.userData.wallName == "G_R_L_F_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "G_B_L_B_W" && isFor == "gableBackLean")) &&

                (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight - 1)) &&
                (-trussDimension.buildingWidth/2 + 1.5) >= (item.positionX - item.width/2)));

            const frontRightCornerBraceOverlapDoors = const_var.newDoorsArray.filter((item) => (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight) && ((
                (item.userData.wallName == "c_b_f_w" || item.userData.wallName == "c_b_l_s_f_w") && (isFor == 'center' || isFor == "gableFrontLean")) || 
                (item.userData.wallName == "G_F_L_B_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_B_L_B_W" && isFor == "gableBackLean") || 
                (item.userData.wallName == "G_L_L_B_W" && isFor == "gableLeftLean") || 
                (item.userData.wallName == "G_R_L_F_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "c_b_b_w" && isFor == "gableBackLean"))) ||

                ((((item.userData.wallName == "c_b_f_w" || item.userData.wallName == "c_b_r_s_f_w") && isFor == 'center') || 
                (item.userData.wallName == "G_F_L_B_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_L_L_B_W" && isFor == "gableLeftLean") || 
                (item.userData.wallName == "G_R_L_F_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "G_B_L_B_W" && isFor == "gableBackLean")) &&

                (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight - 1)) &&
                (trussDimension.buildingWidth/2 - 1.5) <= (item.positionX + item.width/2)));

            const backLeftCornerBraceOverlapDoors = const_var.newDoorsArray.filter((item) => (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight) && ((
                (item.userData.wallName == "c_b_b_w" || item.userData.wallName == "c_b_l_s_b_w") && isFor == 'center') || 
                (item.userData.wallName == "G_F_L_F_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_B_L_F_W" && isFor == "gableBackLean") || 
                (item.userData.wallName == "G_R_L_B_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "G_L_L_F_W" && isFor == "gableLeftLean"))) ||

                ((((item.userData.wallName == "c_b_b_w" || item.userData.wallName == "c_b_r_s_b_w") && isFor == 'center') || 
                (item.userData.wallName == "G_F_L_F_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_B_L_F_W" && isFor == "gableBackLean") || 
                (item.userData.wallName == "G_R_L_B_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "G_L_L_F_W" && isFor == "gableLeftLean")) &&

                (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight - 1)) &&
                ((-trussDimension.buildingWidth/2 + 1.5) >= (-item.positionX - item.width/2))));

            const backRightCornerBraceOverlapDoors = const_var.newDoorsArray.filter((item) => (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight) && ((
                (item.userData.wallName == "c_b_b_w" || item.userData.wallName == "c_b_l_s_b_w") && isFor == 'center') || 
                (item.userData.wallName == "G_F_L_F_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_B_L_F_W" && isFor == "gableBackLean") || 
                (item.userData.wallName == "G_R_L_B_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "G_L_L_F_W" && isFor == "gableLeftLean"))) ||

                ((((item.userData.wallName == "c_b_b_w" || item.userData.wallName == "c_b_r_s_b_w") && isFor == 'center') || 
                (item.userData.wallName == "G_F_L_F_W" && isFor == "gableFrontLean") || 
                (item.userData.wallName == "G_B_L_F_W" && isFor == "gableBackLean") || 
                (item.userData.wallName == "G_R_L_B_W" && isFor == "gableRightLean") || 
                (item.userData.wallName == "G_L_L_F_W" && isFor == "gableLeftLean")) &&

                (item.parent_array_key == "Garage" && item.height >= (trussDimension.buildingHeight - 1)) &&
                ((trussDimension.buildingWidth/2 - 1.5) <= (-item.positionX + item.width/2))));

            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1;
                
                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    //----- upper truss -----
                    obj_upperTrussNormal.position.set(offsetForDir * roofRailData.pos_x, roofRailData.pos_y, trussModelPosInfoArr[index_truss]);
                    obj_upperTrussNormal.rotation.y = offsetForDir * Math.PI / 2;
                    obj_upperTrussNormal.rotateOnAxis(vector, offsetForDir * -roofRailData.alpha);
                    
                    if (!!overlapTrussArr && overlapTrussArr.buildingType === 'center' && overlapTrussArr.idArr.includes(index_truss)) {
                        obj_upperTrussNormal.scale.setScalar(0);
                    } else {
                        obj_upperTrussNormal.scale.setScalar(1);
                    }

                    obj_upperTrussNormal.updateMatrix();
                    if (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right")) {
                        if (index_dir === 0) obj_upperTrussNormal.scale.setScalar(1);
                        else  obj_upperTrussNormal.scale.setScalar(0);

                        obj_upperTrussNormal.updateMatrix();
                        instancedUpperTrussNormal.push(...obj_upperTrussNormal.matrix.elements);
                    } else {
                        instancedUpperTrussNormal.push(...obj_upperTrussNormal.matrix.elements);
                    }
                    //---------------------

                    //----- slope rail-----
                    if (offsetForDir === 1) obj_sideSlopeRail.position.set(offsetForDir * (trussDimension.buildingWidth / 2 - 0.15), rightBraceHeight, trussModelPosInfoArr[index_truss]);
                    else obj_sideSlopeRail.position.set(offsetForDir * (trussDimension.buildingWidth / 2 - 0.15), singleSlopeBracesHeight, trussModelPosInfoArr[index_truss]);
                    
                    obj_sideSlopeRail.rotation.y = offsetForDir * -Math.PI / 2;
                    obj_sideSlopeRail.rotateOnAxis(vector, offsetForDir * -sideEdgeSlopeRailAlpha);

                    let overlap_left, overlap_right = false;
                    leftDoorDataArr.forEach((item) => {
                        if (Object.keys(leftSideWallArr).includes(item.userData.wallName) && isFor == leftSideWallArr[item.userData.wallName]) {
                            if (item.positionX - item.width / 2 < trussModelPosInfoArr[index_truss] + connectRailWidth / 2 &&
                                item.positionX + item.width / 2 >= trussModelPosInfoArr[index_truss] - connectRailWidth / 2 &&
                                item.positionY + item.height / 2 >= singleSlopeBracesHeight
                            ) {
                                overlap_left = true;
                            }
                        }
                    })

                    rightDoorDataArr.forEach((item) => {
                        if (Object.keys(rightSideWallArr).includes(item.userData.wallName) && isFor == rightSideWallArr[item.userData.wallName]) {
                            if (-item.positionX - item.width / 2 < trussModelPosInfoArr[index_truss] + connectRailWidth / 2 &&
                                -item.positionX + item.width / 2 >= trussModelPosInfoArr[index_truss] - connectRailWidth / 2 &&
                                item.positionY + item.height / 2 >= rightBraceHeight
                                ) {
                                    overlap_right = true;
                            }
                        }
                    })

                    if ((offsetForDir === 1 && (overlap_right === true || (controls.isCheckActiveTab === 'doorwindow' && params.activeWall === 'c_b_l_s_r_w'))) || 
                        (offsetForDir === -1 && (overlap_left === true || (controls.isCheckActiveTab === 'doorwindow' && params.activeWall === 'c_b_r_s_l_w'))))
                    {
                        obj_sideSlopeRail.scale.setScalar(0);
                    } else {
                        obj_sideSlopeRail.scale.setScalar(1);
                    }
                    
                    if (offsetForDir === -1 && frontLeftCornerBraceOverlapDoors.length > 0 && index_truss === trussModelPosInfoArr.length - 1) {
                        obj_sideSlopeRail.scale.setScalar(0);
                    }

                    if (offsetForDir === 1 && frontRightCornerBraceOverlapDoors.length > 0 && index_truss === trussModelPosInfoArr.length - 1) {
                        obj_sideSlopeRail.scale.setScalar(0);
                    }

                    if (offsetForDir === -1 && backLeftCornerBraceOverlapDoors.length > 0 && index_truss === 0) {
                        obj_sideSlopeRail.scale.setScalar(0);
                    }

                    if (offsetForDir === 1 && backRightCornerBraceOverlapDoors.length > 0 && index_truss === 0) {
                        obj_sideSlopeRail.scale.setScalar(0);
                    }

                    obj_sideSlopeRail.updateMatrix();
                    instancedSideSlopeRail.push(...obj_sideSlopeRail.matrix.elements);
                                        
                    //----- loft piece rail-----
                    obj_loftPieceRail.position.set(-offsetForDir * (trussDimension.buildingWidth / 2 - connectRailHeight + 0.145), trussDimension.buildingHeight, trussModelPosInfoArr[index_truss] - connectRailWidth / 2 * offsetForDir);
                    if (offsetForDir === 1) obj_loftPieceRail.rotation.y = 0;
                    else obj_loftPieceRail.rotation.y = Math.PI;

                    if (params.singleSlope) obj_loftPieceRail.scale.setScalar(0);
                    else obj_loftPieceRail.scale.setScalar(1);

                    obj_loftPieceRail.updateMatrix();
                    instancedLoftPieceRail.push(...obj_loftPieceRail.matrix.elements);
                    //---------------------
                })
            })                    

            setUpperTrussNormal(new THREE.InstancedBufferAttribute(new Float32Array(instancedUpperTrussNormal), 16));
            setSideSlopeRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedSideSlopeRail), 16));
            setLoftPieceRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedLoftPieceRail), 16));
        
    }, [trussModelPosInfoArr, overlapTrussArr, roofRailData, singleSlopeBracesHeight, rightBraceHeight, rightBraceHeight, leftDoorDataArr, params.singleSlope, params.freeStandingSide, trussDimension.buildingHeight, trussDimension.buildingWidth, trussDimension.roofPitch, controls.isCheckActiveTab, params.activeWall])
    
    return (
        <>
            <group position={[0, -offset, 0]} name='garage-truss-legs'>
                {/* --- upper truss model --- */}
                {
                    (isFor === 'center' || (isFor !== undefined && !isFor.includes('gable'))) && upperTrussNormal.array.length && [1].map((_, index) =>
                    <instancedMesh key={upperTrussNormal.array.length} instanceMatrix={upperTrussNormal} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(roofRailData.length - (0.05 - (parseFloat(trussDimension.roofPitch) - 3) * 0.017 / 3))]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {/* ------------------------- */}

                {/* --- slope rail model --- */}
                {
                    isFor !== undefined && isShowSlopeRail && sideSlopeRail.array.length && [1].map(() =>
                    <instancedMesh key={sideSlopeRail.array.length} instanceMatrix={sideSlopeRail} instanceMatrix-needsUpdate={true} name='left_leg_right_leg_brace' args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(sideEdgeSlopeRailLength - 0.15)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {/* ------------------------- */}
        
                {/* --- loft piece rail model --- */}
                {
                    params.p_r_s === 1 && loftPieceRail.array.length && [1].map(() =>
                    <instancedMesh key={loftPieceRail.array.length} instanceMatrix={loftPieceRail} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                        <extrudeGeometry args={[railLoftModel(connectRailHeight, trussDimension.roofPitch), extrudeSettings(connectRailWidth)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {/* ------------------------- */}
            </group>
        </>
    )
}

export default CommonTruss